export default __webpack_public_path__ + "static/media/krowd_logo_login.8ce1fc7e.png";